module.exports = __webpack_public_path__ + "core-fonts/maxpro_s-light-webfont.b2d3169860974cea04f997e7c5ba54ad.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/font/maxpro_s-light-webfont.eot
// module id = 17
// module chunks = 0